import React, { useEffect, useState } from "react";
import { useGeld } from "../context/GeldContext";

const GeldTransaction = () => {
  const { pendingTransactions } = useGeld();
  const [animations, setAnimations] = useState([]);

  // Create new animations when transactions are added
  useEffect(() => {
    // Add new animations for each transaction
    const newAnimations = pendingTransactions.filter(
      (tx) => !animations.some((anim) => anim.id === tx.id)
    );

    if (newAnimations.length > 0) {
      setAnimations((prev) => [...prev, ...newAnimations]);

      // Remove animations after they finish
      const timers = newAnimations.map((anim) => {
        return setTimeout(() => {
          setAnimations((prev) => prev.filter((a) => a.id !== anim.id));
        }, 2000); // Animation duration
      });

      return () => timers.forEach((timer) => clearTimeout(timer));
    }
  }, [pendingTransactions, animations]);

  return (
    <>
      {/* Add CSS keyframes for the animations */}
      <style>
        {`
          @keyframes coinFlyUp {
            0% { 
              transform: translate(-50%, 0) scale(0.5); 
              opacity: 0; 
            }
            10% { 
              transform: translate(-50%, -20px) scale(1); 
              opacity: 1; 
            }
            80% { 
              transform: translate(-50%, -100px) scale(1); 
              opacity: 1; 
            }
            100% { 
              transform: translate(-50%, -120px) scale(0.8); 
              opacity: 0; 
            }
          }
        `}
      </style>

      {/* Render each animation */}
      {animations.map((anim) => (
        <div
          key={anim.id}
          style={{
            position: "fixed",
            bottom: "80px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "coinFlyUp 2s forwards",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              backgroundColor: "#f3e1b2",
              borderRadius: "12px",
              padding: "6px 12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            <span>+{anim.amount} </span>
            <img
              src="/geld.png"
              alt="geld"
              style={{
                width: "18px",
                height: "18px",
                objectFit: "contain",
                verticalAlign: "middle",
              }}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default GeldTransaction;
